<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-row>
                    <v-col cols="12">
                        <v-card class="px-4 py-4" flat>
                            <v-select
                                :items="(new $db.Product).productTypes"
                                item-value="id"
                                item-text="text"
                                v-model="form.type"
                                v-validate="'required'"
                                :error-messages="errorMessages('type')"
                                :class="{ 'error--text': hasErrors('type') }"
                                class="primary--text"
                                name="type"
                                label="Tip articol"
                                data-vv-as="Tip articol"
                                data-vv-name="type"
                            />
                            <v-text-field
                                v-model="form.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('name')"
                                :class="{ 'error--text': hasErrors('name') }"
                                class="primary--text"
                                name="name"
                                label="Denumire"
                                data-vv-as="Denumire"
                                data-vv-name="name"
                                counter="255"
                            />
                            <v-text-field
                                v-model="form.product_number"
                                v-validate="'required'"
                                :error-messages="errorMessages('product_number')"
                                :class="{ 'error--text': hasErrors('product_number') }"
                                class="primary--text"
                                name="product_number"
                                label="Cod produs"
                                data-vv-as="Cod produs"
                                data-vv-name="product_number"
                                counter="255"
                            />
                            <v-textarea
                                v-model="form.description"
                                :error-messages="errorMessages('description')"
                                :class="{ 'error--text': hasErrors('description') }"
                                class="primary--text"
                                name="description"
                                label="Observatii"
                                data-vv-as="Observatii"
                                data-vv-name="description"
                            />
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-btn
                            :loading="form.busy"
                            :disabled="errors.any() || form.busy"
                            block
                            color="success"
                            @click="submit()"
                        >
                            Salveaza
                            <v-icon right>
                                save
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import openAPI from "Mixins/openapi";
    import {Form} from "vform";

    export default {
        mixins: [validationError, openAPI],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                workstation_id: null,
                type: null,
                name: null,
                product_number: null,
                description: null,
                available_stock: null,
                data: {},
            }),
        }),
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Product.find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Product(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "products-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
